import { NgModule } from '@angular/core';
import { NumberCounterComponent } from './number-counter.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        NumberCounterComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        NumberCounterComponent
    ]
})
export class NcNumberCounterModule { }